import axios from 'axios'
import { apiUrl } from '@/api/apiUrl'

import {
  _
} from "vue-underscore"

const state = {
  afrules: []
}

const mutations = {
  FETCH_AF_RULES(state, item) {
    state.afrules = item
  }
}

const actions = {
  async getRules({
    commit
  }) {
      let config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      return await axios.post(apiUrl + "antifraud/rule", {}, config)
        .then(({
          data
        }) => {
          if (data.state_id == 0 && data.total > 0) {
            commit('FETCH_AF_RULES', data.list)
            return data
          }
        })
  }
}

const getters = {
  afrulesList(state) {
    return state.afrules
  },
  afruleName: state => id => {
    if (state.afrules && state.afrules.length > 0 && id != undefined) {
      let item = state.afrules.find(el => el.id === id)
      if (item != undefined) return item['name']
      else return ""
    } else return ""
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
